module.exports = __webpack_public_path__ + "static/media/product-5.dfdc6e5a.png";